<template>
  <span
    v-if="companyCode"
    class="badge badge-pill"
    :style="{ backgroundColor: badgeColor, color: '#fff' }"
    v-b-tooltip.hover.top
    :title="companyName || companyCode"
  >{{ companyCode }}</span>
</template>

<script>
import { getCompanyCodeColor } from '@/utils/common';

export default {
  name: 'CompanyCodeBadge',
  props: {
    companyCode: {
      type: String,
      default: null,
    },
    companyName: {
      type: String,
      default: null,
    },
  },
  computed: {
    badgeColor() {
      return getCompanyCodeColor(this.companyCode);
    },
  },
};
</script>
